import { i18n } from '@/shared/i18n';
import type { Column } from '@/shared/ui';
import type { WorkspaceRule } from './WorkspaceWhitelistRulesTable';

// Getters, not values: this array is built while the module is evaluated, so resolving per
// read is what lets a header follow a language change instead of freezing at import.
export const COLUMNS: Column<WorkspaceRule>[] = [
  {
    key: 'workspaceName',
    get label() {
      return i18n.t('admin:admin.workspaceWhitelistRulesTable.workspace');
    },
    sortable: true,
    className: 'w-[40%]',
  },
  {
    key: 'providers',
    get label() {
      return i18n.t('admin:admin.workspaceWhitelistRulesTable.whitelistedProviders');
    },
    sortable: false,
    className: 'w-[60%]',
  },
];
